import { css } from 'linaria';

export const newKitchenSignSectionPanelWrapper = css`
  width: 100%;
`;

export const newKitchenSignSectionPanel = css`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0;

  @media (--only-mobile) {
    display: none;
  }
`;

export const newKitchenSignSectionPanelIcon = css`
  margin-right: 34px;
  @media (--to-desktop) {
    display: none;
  }
`;

export const newKitchenSignSectionPanelText = css`
  @media (--to-desktop) {
    display: none;
  }
`;

export const newKitchenSignSectionPanelButtons = css`
  display: flex;
  margin-left: auto;
  column-gap: 24px;

  @media (--to-desktop) {
    && a {
      padding: 10px 20px;
    }
  }
`;

export const newKitchenSignSectionPanelMobileButton = css`
  @media (--from-tablet) {
    display: none;
  }
`;
